// extracted by mini-css-extract-plugin
export default {"singleFileItem":"SingleFile_singleFileItem__GUTXx"};